import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { selectClientsById } from '../users/usersSlice';
import WearablesChart from './WearablesChart';
import {Spinner} from "react-bootstrap"
import {envAwarePost} from '../../util/util'
function Wearables() {
    const dispatch = useDispatch();

    //grabs the client ID from the URL
    const url = new URL(window.location.href);
    const clientId = url.searchParams.get("clientId");
    console.log(clientId);
    const client = useSelector(state => selectClientsById(state, clientId))

    let payload = { client_id: clientId }

    const [status,setStatus] = useState('idle')
    const [data,setData] = useState([])

    useEffect(()=>{
        setStatus('pending')
        envAwarePost('api/wearables/',{action:'readAllData',client_id:clientId}).then(res=>{
           setData(res.data.health)
           setStatus('idle')
        })
    },[])

  
    let measurementSystem = useSelector(state => state.wearable.measurementSystem)

    return (
        <>
            <div className='pt-2 px-2 px-md-3'>
                <strong> {client?.user_name ? `${client.user_name}'s Wearable Data` : "Clients Health Data"}</strong>
            </div>
            <hr />
            {(status==='pending') ? <Spinner animation="border" role="status"> <span className="sr-only">Loading...</span> </Spinner> :
                data.map(d=>(
                    <div key={d.name} className="mb-4"  >
                        <WearablesChart 
                            chartData={d.data} 
                            healthType={d.name} 
                            unit={d.data[0].units} 
                            color='rgba(75, 192, 192, 0.6)'
                        />
                    </div>
                ))
            }

        </>
    )

}

export default Wearables;